module.exports = __webpack_public_path__ + "img/roomescape_title.732273c9.png";